import { useEffect } from 'react';

interface ScrollToTopProps {
  children: React.ReactNode;
}

export const ScrollToTop = ({ children }: ScrollToTopProps) => {
  useEffect(() => {
    const prev = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return () => {
      window.history.scrollRestoration = prev;
    };
  }, []);
  return <>{children}</>;
};
